import React, { createContext, useContext } from 'react'

import { BreakpointIdentifier, theme } from '@emico/styles'

import { GridBreakpoints, GridContainerProps } from './Grid'

export const initialGridLayout: GridBreakpoints = {
  [BreakpointIdentifier.xs]: {
    columns: theme.gridColumns.xs,
    gutter: theme.gridGutterWidths.xs,
  },
  [BreakpointIdentifier.sm]: {
    columns: theme.gridColumns.sm,
    gutter: theme.gridGutterWidths.sm,
  },
  [BreakpointIdentifier.md]: {
    columns: theme.gridColumns.md,
    gutter: theme.gridGutterWidths.md,
  },
  [BreakpointIdentifier.lg]: {
    columns: theme.gridColumns.lg,
    gutter: theme.gridGutterWidths.lg,
  },
  [BreakpointIdentifier.xl]: {
    columns: theme.gridColumns.xl,
    gutter: theme.gridGutterWidths.xl,
  },
}

interface GridContextProps {
  layout: GridBreakpoints
}

interface Props {
  state: GridContainerProps
  children: React.ReactNode
}

const GridConfigContext = createContext<GridContextProps>({
  layout: initialGridLayout,
})

const GridConfigProvider = ({ state, children }: Props) => (
  <GridConfigContext.Provider value={state}>
    {children}
  </GridConfigContext.Provider>
)

function useGridConfig() {
  const context = useContext(GridConfigContext)
  if (context === undefined) {
    throw new Error('useGridConfig must be used within a GridConfigProvider')
  }
  return context
}

export { GridConfigProvider, useGridConfig }
